export function initInScope($scope) {
    let $iframes = $scope.find('.js-iframe-resizing');

    import('iframe-resizer').then(({default: {iframeResize}}) => {
        $iframes.each((_, iframe) => {
            iframeResize( {}, iframe );
        })
    });
}